import GoogleIcon from '@/components/common/GoogleIcon';
import Button from '@/components/common/Button';

interface SocialLoginButtonsProps {
  onGoogleClick: () => void;
  label?: 'signin' | 'signup';
}

/**
 * Social login buttons section with a divider.
 * Used on both the Login and Signup pages.
 */
export default function SocialLoginButtons({ onGoogleClick, label = 'signin' }: SocialLoginButtonsProps) {
  const googleLabel = label === 'signup' ? 'Sign up with Google' : 'Continue with Google';

  return (
    <div>
      {/* Google button */}
      <Button
        type="button"
        variant="secondary"
        className="w-full"
        onClick={onGoogleClick}
      >
        <GoogleIcon className="mr-2 h-5 w-5" />
        {googleLabel}
      </Button>

      {/* Divider */}
      <div className="relative my-5">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-neutral-300" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-neutral-200 px-3 text-neutral-500">or</span>
        </div>
      </div>
    </div>
  );
}
